<template>
    <el-container class="hvh">
        <!-- 左侧导航 -->
        <el-aside class="h100 text_c" width="150px">
            <p class="user_name color_f fs_28 over_ell">{{userName}}</p>
            <p class="color_f" style="margin-bottom:20px"><span @click="loginOut" class="pointer">退出</span></p>
            <el-menu
                class="el-menu-vertical-demo"
                :default-active="activeMenu"
                background-color="#545c64"
                text-color="#fff"
                active-text-color="#409EFF">
                <router-link v-for="(item,index) in route" :key="index" v-if="index>0 && index<3" :to="item.path">
                    <el-menu-item :index="item.redirect">
                        <span slot="title">{{item.name}}</span>
                    </el-menu-item>
                </router-link>
                <router-link v-for="(item,index) in route" :key="index" v-if="index==3 && userName=='sevedu'" :to="item.path">
                    <el-menu-item :index="item.redirect">
                        <span slot="title">{{item.name}}</span>
                    </el-menu-item>
                </router-link>
                <a class="color_f" :href="downloadUrl">
                    <el-menu-item>下载模板</el-menu-item>
                </a>
            </el-menu>
        </el-aside>
        <!-- 主体部分 -->
        <el-container>
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
export default {
    name: "Layout",
    data(){
        return{
            route: this.$router.options.routes, // 路由列表
            userName: window.localStorage.getItem('username'),
            downloadUrl: window.sessionStorage.getItem('domain')+"/api/file/downloadFile"
        }
    },
    computed: {
        // 当前路由
        activeMenu() {
            const route = this.$route
            const { path } = route
            return path
        }
    },
    methods:{
        loginOut(){
            localStorage.removeItem('username')
            localStorage.removeItem('static_token')
            this.$router.push({
                path:"/login"
            })
        }
    },
    mounted(){
        let token=window.localStorage.getItem('static_token')
        if(token=="" || token==null || token==undefined){
            this.$router.push({path:"/login"})
        }
    }
}
</script>
<style scoped>
.el-aside{
    background-color: rgb(84, 92, 100);
}
.el-menu{
    border-right: none;
}
.el-main{
    padding: 0;
}
.user_name{
    padding: 40px 0 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue